import { ResourcesConfig } from 'aws-amplify';

import { environment } from '../../../environments/environment';

/**
 * Configuração do Amplify para o User Pool da plataforma (single-tenant). Os
 * valores vêm do `environment` ativo (DEV em `ng serve`/`build:dev`, PROD via
 * fileReplacements no build de produção) — não é mais hardcoded.
 *
 * O scope `aws.cognito.signin.user.admin` é necessário para o access token poder
 * chamar `GetUser` — é assim que o authorizer (api-authorizer) valida o token e
 * lê `cognito:groups`. O Amplify escolhe o redirect pela origem atual.
 *
 * ⚠️ Os redirects vêm do `environment` (DEV inclui `localhost` p/ o `ng serve`;
 * **PROD NUNCA inclui `localhost`** — só a URL hospedada). Como `environment.ts`
 * (dev) é trocado por `environment.prod.ts` no build de produção, o `localhost`
 * nem entra no bundle de prod.
 */
const { userPoolId, userPoolClientId, domain, redirectSignIn, redirectSignOut } = environment.cognito;

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain,
          scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code',
        },
      },
    },
  },
};
